import React, { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { useEditorStore } from '../../../../hooks/EditorState';

// load plugin types from the server when appState exists
export function PluginTypesLoader(props: {
  shouldLoad?: boolean;
  children: React.ReactNode;
}) {
  const apolloClient = useApolloClient();
  const loadStaticTypes = useEditorStore(state => state.graphql.loadStaticTypes);
  // use this to load dynamic types
  const loadDynamicTypes = useEditorStore(state => state.graphql.loadDynamicTypes);
  const [staticTypesLoaded, setStaticTypesLoaded] = useState(false);
  const [dynamicTypesLoaded, setDynamicTypesLoaded] = useState(false);

  useEffect(() => {
    if (props.shouldLoad) {
      loadStaticTypes(apolloClient).finally(() => setStaticTypesLoaded(true));
      // important to pass null as appId here to not update appState
      // the goal is to load required dynamic types for constructed plugins in the current appState nodes
      loadDynamicTypes(apolloClient).finally(() => setDynamicTypesLoaded(true));
    }
  }, [props.shouldLoad, apolloClient]);

  // TODO visual indication that loading is in progress
  return (!props.shouldLoad || (staticTypesLoaded && dynamicTypesLoaded)) && <>{props.children}</>;
}
